import { useState, useEffect, useRef } from 'react';

// API URL - runtime detection for both preview and deploy
const getApiUrl = () => {
  if (typeof window === 'undefined') return 'http://localhost:8001/api';
  
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8001/api';
  }
  
  return '/api';
};

function MarketTicker() {
  const [trendingStocks, setTrendingStocks] = useState([]);
  const refreshIntervalRef = useRef(null);

  // Trend hisseleri çek
  const fetchTrendingStocks = async () => {
    try {
      const response = await fetch(`${getApiUrl()}/assets/trending/top5`);
      if (response.ok) {
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          setTrendingStocks(data);
          console.log('📈 Trend hisseler güncellendi:', data.length, 'adet');
        }
      }
    } catch (error) {
      console.error('Trend hisseler çekilemedi:', error);
    }
  };

  useEffect(() => {
    // İlk yüklemede hemen çek
    fetchTrendingStocks();
    
    // Her 30 saniyede bir güncelle
    refreshIntervalRef.current = setInterval(fetchTrendingStocks, 30000);

    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }
    };
  }, []);

  if (trendingStocks.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-b border-gray-700 overflow-hidden">
      <div className="ticker-wrapper">
        <div className="ticker-content">
          {/* İlk set - Trend Hisseler */}
          {trendingStocks.map((stock, idx) => {
            const price = stock.current_price || 0;
            const changePercent = stock.change_percent || 0;
            
            if (price === 0) return null;
            
            return (
              <div key={`trend-1-${idx}`} className="ticker-item">
                <span className="ticker-symbol">{stock.symbol}</span>
                <span className="ticker-price">₺{price.toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                <span className={`ticker-change ${changePercent >= 0 ? 'positive' : 'negative'}`}>
                  {changePercent >= 0 ? '▲' : '▼'} %{Math.abs(changePercent).toFixed(2)}
                </span>
              </div>
            );
          })}
          
          {/* İkinci set (seamless loop için) */}
          {trendingStocks.map((stock, idx) => {
            const price = stock.current_price || 0;
            const changePercent = stock.change_percent || 0;
            
            if (price === 0) return null;
            
            return (
              <div key={`trend-2-${idx}`} className="ticker-item">
                <span className="ticker-symbol">{stock.symbol}</span>
                <span className="ticker-price">₺{price.toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                <span className={`ticker-change ${changePercent >= 0 ? 'positive' : 'negative'}`}>
                  {changePercent >= 0 ? '▲' : '▼'} %{Math.abs(changePercent).toFixed(2)}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <style jsx>{`
        .ticker-wrapper {
          width: 100%;
          overflow: hidden;
          padding: 0.25rem 0;
        }

        .ticker-content {
          display: flex;
          align-items: center;
          animation: scroll 40s linear infinite;
          white-space: nowrap;
        }

        .ticker-item {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1.25rem;
          border-right: 1px solid rgba(75, 85, 99, 0.3);
        }

        .ticker-symbol {
          font-weight: 700;
          color: #fff;
          font-size: 0.875rem;
        }

        .ticker-price {
          color: #d1d5db;
          font-size: 0.875rem;
          font-family: 'JetBrains Mono', monospace;
        }

        .ticker-change {
          font-size: 0.8rem;
          font-weight: 700;
          padding: 0.125rem 0.5rem;
          border-radius: 0.25rem;
        }

        .ticker-change.positive {
          color: #10b981;
          background: rgba(16, 185, 129, 0.15);
        }

        .ticker-change.negative {
          color: #ef4444;
          background: rgba(239, 68, 68, 0.15);
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .ticker-content:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}

export default MarketTicker;
